'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  title: string;
  subtitle?: string;
  tag?: 'h1' | 'h2' | 'h3';
  className?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}

export function Heading({ title, subtitle, className, tag = 'h2' }: HeadingProps) {
  const Tag = tag;

  return (
    <div className={cn('flex flex-col gap-4 sm:gap-5 lg:gap-6 ', className?.container)}>
      {subtitle && (
        <h3
          className={cn(
            'flex items-center gap-2 text-sm font-normal leading-[1.1] tracking-tight text-primary sm:text-base sm:leading-[1.1]',
            className?.subtitle,
          )}
        >
          <Image
            src={'/images/star.svg'}
            alt={subtitle}
            width={8.5}
            height={8}
            className="object-contain"
          />
          {subtitle}
        </h3>
      )}
      <HtmlRendererRaw
        as={Tag}
        className={cn(
          'ea-heading__title',
          tag === 'h1' && 'text-[40px] sm:text-5xl lg:text-5xl xl:text-7xl',
          tag === 'h2' && 'text-[32px] sm:text-4xl lg:text-5xl',
          tag === 'h3' && 'text-2xl sm:text-3xl lg:text-[32px]',
          'font-semibold leading-[1.2] tracking-tighter text-black sm:leading-[1.2] lg:leading-[1.2] xl:leading-[1.2]',
          className?.title,
          tag,
        )}
        html={title}
      />
    </div>
  );
}
